import Vue from 'vue'

import { cloneDeep, pick } from 'lodash'

import { generateServices, globalErrorHandler, services } from '@/utils'

import { tariffInputFilter, tariffOutputFilter } from '@/components/services/tariffs/utils'

import render from './render'

export default {
  name: `${services.tariffs}ButtonsDouble`,

  mixins: [
    generateServices({
      name: services.tariffs,

      inputFilter: tariffInputFilter,
      outputFilter: tariffOutputFilter,

      get: false,
      update: false,
      remove: false
    })
  ],

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    validation: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      loading: false,

      divideByHundred: false,
      showSimilarDialog: false,
      showConfirmDialog: false,
      similarTariffs: []
    }
  },

  computed: {
    cloneActionsAreAvailable() {
      return !this.loading && this.validation && this.checkPermissions(`advanced.${services.tariffs}.create`)
    }
  },

  methods: {
    async submitCreateTariff(payload) {
      const response = await this.rest[services.tariffs].create(payload)
      if (response) {
        Vue.router.push({
          name: `${services.tariffs}.single`,
          params: { id: response.id }
        })
      }
    },

    async createTariff(payload) {
      if (!this.cloneActionsAreAvailable) {
        return
      }

      try {
        this.loading = true
        await this.submitCreateTariff(payload)
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
        this.divideByHundred = false
      }
    },

    async cloneTariff(divideByHundred = false) {
      if (!this.cloneActionsAreAvailable) {
        return
      }

      try {
        this.loading = true
        const payload = this.processPayload(divideByHundred)
        this.similarTariffs = await this.rest[services.tariffs].find({ query: { title: payload.title } })
        if (Array.isArray(this.similarTariffs) && this.similarTariffs.length) {
          const exactMatch = this.similarTariffs.find(tariff => {
            return tariff.title === payload.title
          })
          if (exactMatch) {
            this.showSimilarDialog = true
            this.loading = false

            return
          }
        }

        await this.submitCreateTariff(payload)
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
        if (!this.showSimilarDialog) {
          this.divideByHundred = false
        }
      }
    },

    titleSuffix(payload) {
      const regex = /_(\d+)$/
      const match = payload.title.match(regex)
      if (match) {
        const index = parseInt(match[1])
        payload.title = payload.title.replace(regex, `_${index + 1}`)
      } else {
        payload.title = `${payload.title}_2`
      }

      return payload
    },

    dividePricesByHundred(payload) {
      for (const rule of payload.data.rules) {
        if (rule.price) {
          if (!Array.isArray(rule.price)) {
            rule.price = [ rule.price ]
          }

          rule.price = rule.price.map(price => {
            const [ integer, decimal ] = price.toString().split('.')
            const integers = integer.split('')
            const integersAfterDivide = integers.splice(-2)
            let integersStr
            if (integers.length) {
              integersStr = integers.join('')
            } else {
              integersStr = '0'
            }
            const result = [
              integersStr,
              (integersAfterDivide.join('').padStart(2, '0') + decimal).slice(0, 4)
            ]

            return parseFloat(result.join('.'))
          })
        }
      }

      return payload
    },

    processPayload(divideByHundred = false) {
      const payload = pick(cloneDeep(this.value), [ 'title', 'source', 'data', 'isActive' ])
      this.titleSuffix(payload, divideByHundred)
      if (divideByHundred) {
        this.dividePricesByHundred(payload)
      }

      return payload
    }
  },

  render
}
